module.exports = __webpack_public_path__ + "20251203d193705t/img/production-pic.2a7c54ea.png";